var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDecline = function SvgDecline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0 5.556-4.444 10-10 10S2 17.556 2 12 6.444 2 12 2s10 4.444 10 10m-2.222 0A7.73 7.73 0 0 0 12 4.222 7.73 7.73 0 0 0 4.222 12 7.73 7.73 0 0 0 12 19.778 7.73 7.73 0 0 0 19.778 12M8.667 16.444c-.334 0-.556-.11-.778-.333a1.074 1.074 0 0 1 0-1.555L10.444 12 7.89 9.444a1.074 1.074 0 0 1 0-1.555 1.074 1.074 0 0 1 1.555 0L12 10.444l2.556-2.555a1.074 1.074 0 0 1 1.555 0 1.074 1.074 0 0 1 0 1.555L13.556 12l2.555 2.556a1.074 1.074 0 0 1 0 1.555 1.2 1.2 0 0 1-.778.333 1.2 1.2 0 0 1-.777-.333L12 13.556 9.444 16.11c-.222.222-.444.333-.777.333",
    clipRule: "evenodd"
  })));
};
export default SvgDecline;